var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcRadioChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 16,
  height: 16,
  x: 1,
  y: 1.5,
  stroke: "#4D4D4D",
  strokeWidth: 2,
  rx: 8
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 11.571,
  height: 11.571,
  x: 3.215,
  y: 3.711,
  fill: "#4D4D4D",
  rx: 5.786
})));
export default SvgIcRadioChecked;